import React from 'react';
import LegalLayout from './LegalLayout';

const DataDeletion = () => (
  <LegalLayout title="Data Deletion Request" lastUpdated="2026-04-30">
    <p>
      Gainrhino CRM stores lead contact details (name, email, phone) submitted
      through your Facebook Lead Ads, web forms or other channels, plus any
      notes, messages and CRM activity created by our customers' teams about
      those leads.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">How to request deletion</h2>
    <p>
      To request deletion of your personal data from Gainrhino CRM, send an
      email to{' '}
      <a href="mailto:info@gainrhino.com" className="text-primary-600 hover:underline">info@gainrhino.com</a>{' '}
      with the subject <strong>"Data Deletion Request"</strong> and include the following:
    </p>
    <ul className="list-disc pl-6 space-y-1">
      <li>Your full name</li>
      <li>The email address used in any form you submitted</li>
      <li>(Optional but speeds up processing) the Facebook Page name where the form was hosted</li>
    </ul>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">What happens next</h2>
    <p>
      We process deletion requests within 30 days. We will email you a
      confirmation when complete. If we cannot identify you with the
      information provided we may follow up to verify your identity before
      taking action.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">Retention exceptions</h2>
    <p>
      Some data may be retained beyond your deletion request where required by
      applicable law (for example tax, accounting, or anti-fraud obligations)
      or to defend against legal claims. Such retained data is kept only for
      the minimum period required and is not used for any other purpose.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">If you used a customer's form</h2>
    <p>
      If you submitted your contact details through a form hosted by one of
      Gainrhino's customers (for example a dental clinic), we recommend also
      contacting that business directly so they can delete you from their
      records on their end. We can coordinate with them on your behalf if you
      ask us to.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">Questions</h2>
    <p>
      For any questions about this process, email{' '}
      <a href="mailto:info@gainrhino.com" className="text-primary-600 hover:underline">info@gainrhino.com</a>.
    </p>
  </LegalLayout>
);

export default DataDeletion;
